export const CHART_MARGIN = {
  top: 24,
  bottom: 8,
  right: 24,
  left: 0,
};

export const CHART_HEIGHT = 140;
